import { Outlet } from "react-router";
import { useTypedParams } from "react-router-typesafe-routes";

import { Tabs } from "@design-system/Tabs/Tabs";

import { PortalSubNavigationTabs } from "@layouts/PortalPage/PortalSubNavigationTabs";

import { routes } from "@pages/routes";

export const ClientNotificationsLayout = () => {
  const { clientId } = useTypedParams(routes.portal.clients.client);

  return (
    <>
      <PortalSubNavigationTabs>
        <Tabs style={{ borderBottom: "none", gap: "24px" }}>
          <Tabs.Tab
            name="Notifications"
            to={routes.portal.clients.client.notifications.index.$buildPath({
              params: { clientId },
            })}
            end={true}
          />
          <Tabs.Tab
            name="History"
            to={routes.portal.clients.client.notifications.history.$buildPath({
              params: { clientId },
            })}
          />
        </Tabs>
      </PortalSubNavigationTabs>
      <Outlet />
    </>
  );
};
